import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Banner, BannerFormData, defaultBannerTimezone, defaultTimezoneOption } from '../models/BannersModels';

interface BannersStateData {
  form: BannerFormData;
  activeBanners: Banner[];
}

const initialState: BannersStateData = {
  form: {
    bannerType: '',
    scope: '',
    selectedMarkets: [],
    selectedCompanies: [],
    bannerTitle: '',
    timezone: defaultBannerTimezone,
    timezoneOption: defaultTimezoneOption,
    startDate: '',
    endDate: '',
    maintenanceTimezone: defaultBannerTimezone,
    maintenanceTimezoneOption: defaultTimezoneOption,
    maintenanceStart: '',
    maintenanceEnd: '',
    messages: {},
    dismissible: false,
  },
  activeBanners: [],
};

export const BannersSlice = createSlice({
  name: 'banners',
  initialState,
  reducers: {
    // only resets the form, the active banners are kept since they are displayed across the portal
    reset: (state) => {
      state.form = initialState.form;
    },
    updateBannerForm: (state, action: PayloadAction<Partial<BannerFormData>>) => {
      state.form = {
        ...state.form,
        ...action.payload,
      };
    },
    setActiveBanners: (state, action: PayloadAction<Banner[]>) => {
      state.activeBanners = action.payload;
    },
  },
});

export const { reset, updateBannerForm, setActiveBanners } = BannersSlice.actions;

export default BannersSlice.reducer;
